import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/news/page.tsx");
